import { keyBy } from 'lodash';

/**
 * Settings for entire site
 *
 * Note that empty nodes are loaded when the user logs in @see store/modules/account.js
 */

function createDefinition(type, keypath) {
  return {
    id: type,
    keypath: `${keypath}.${type}`,
  };
}

function getKeypath(types, id) {
  if (!types[id]) {
    return id;
  }

  const { keypath } = types[id];

  return keypath;
}

export function getEventKeypath(id) {
  return getKeypath(keyedEventTypes, id);
}

export function getTransportKeypath(id) {
  return getKeypath(keyedTransportTypes, id);
}

export function getStationaryKeypath(id) {
  return getKeypath(keyedStationaryTypes, id);
}

export const driving = {
  types: ['smooth_v2', 'legal_v2', 'anticipative_v2', 'focus'],
};

export const transportModes = [
  'car',
  'walking',
  'biking',
  'train',
  'bus',
  'tram',
  'subway',
  'boat',
  'motorcycle',
  'flight',
  'running',
];

export const stationaryLocations = [
  'home',
  'work',
  'regular',
  'nonregular',
  'poi',
  'new',
];

export const segmentCategories = [
  'work_life',
  'mobility',
  'leisure',
  'other',
  'custom',
];

export const stationaryTypes = stationaryLocations.map(type =>
  createDefinition(type, 'types.events.stationaries')
);
export const transportTypes = transportModes.map(type =>
  createDefinition(type, 'types.events.transports')
);
export const segmentCategoryTypes = segmentCategories.map(type =>
  createDefinition(type, 'types.segments.categories')
);

const oddTypes = ['idle', 'insufficient_data'].map(type =>
  createDefinition(type, 'types.events.transports')
);
const eventTypes = [...stationaryTypes, ...transportTypes, ...oddTypes];
const keyedTransportTypes = keyBy(transportTypes, 'id');
const keyedStationaryTypes = keyBy(stationaryTypes, 'id');
const keyedEventTypes = keyBy(eventTypes, 'id');

export default {
  driving,
  transportModes,
  stationaryLocations,
  segmentCategories,
};
